import { useEffect } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import Button from "../common/Button";
import Input from "../common/Input";
import { settingsService } from "../../services/settings";
import toast from "react-hot-toast";
import { Save } from "lucide-react";

const CompanyProfile = () => {
  const queryClient = useQueryClient();
  const { data: settings } = useQuery({
    queryKey: ["settings"],
    queryFn: settingsService.get,
  });
  const { register, handleSubmit, reset } = useForm();
  const mutation = useMutation({
    mutationFn: settingsService.update,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["settings"] });
      toast.success("Settings updated");
    },
  });

  useEffect(() => {
    if (settings) reset(settings);
  }, [settings, reset]);

  const onSubmit = (data) => mutation.mutate(data);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-5 max-w-lg">
      <Input label="Company Name" {...register("companyName")} />
      <Input label="Company Email" type="email" {...register("companyEmail")} />
      <Input label="Company Phone" {...register("companyPhone")} />
      <Input label="Address" {...register("address")} />
      <Button type="submit" disabled={mutation.isPending}>
        <Save className="w-4 h-4 mr-1.5" />
        {mutation.isPending ? "Saving..." : "Save Changes"}
      </Button>
    </form>
  );
};

export default CompanyProfile;
